// Table rows for CPC epoch summaries (checkpoint-derived).

import { Text } from '@mysten/ui';

import { SuiAmount } from '../Table/SuiAmount';
import { TxTimeType } from '../tx-time/TxTimeType';
import { HighlightedTableCol } from '~/components/Table/HighlightedTableCol';
import { CheckpointSequenceLink, EpochLink } from '~/ui/InternalLink';
import type { CpcEpochSummary } from '~/utils/cpcEpochFromCheckpoints';

export function genTableDataFromCpcEpochsData(epochs: CpcEpochSummary[]) {
	return {
		data: epochs.map((epoch) => ({
			epoch: (
				<HighlightedTableCol first>
					<EpochLink epoch={epoch.epoch.toString()} />
				</HighlightedTableCol>
			),
			transactions: (
				<Text variant="bodySmall/medium">{epoch.epochTotalTransactions.toString()}</Text>
			),
			stakeRewards: <SuiAmount amount={epoch.stakeRewards} />,
			checkpointSet: (
				<div>
					<CheckpointSequenceLink sequence={epoch.firstCheckpointId} />
					{` - `}
					<CheckpointSequenceLink sequence={epoch.lastCheckpointId} />
				</div>
			),
			storageNetInflow: (
				<div className="pl-3">
					<SuiAmount amount={epoch.storageNetInflow} />
				</div>
			),
			time: epoch.isCurrent ? (
				<Text variant="bodySmall/medium" color="steel">
					In progress
				</Text>
			) : (
				<TxTimeType timestamp={epoch.epochEndTimestamp ?? undefined} />
			),
		})),
		columns: [
			{ header: 'Epoch', accessorKey: 'epoch' },
			{ header: 'Transaction Blocks', accessorKey: 'transactions' },
			{ header: 'Stake Rewards', accessorKey: 'stakeRewards' },
			{ header: 'Checkpoint Set', accessorKey: 'checkpointSet' },
			{ header: 'Storage Net Inflow', accessorKey: 'storageNetInflow' },
			{ header: 'Epoch End', accessorKey: 'time' },
		],
	};
}
